import { useEffect, useRef, useState } from 'react';

import useTrans from '../../../../hooks/ui/useTrans';
import Row from '../../../Row/Row';
import Spacer from '../../../Spacer/Spacer';
import Stack from '../../../Stack/Stack';
import SubmitButton from '../../../SubmitButton/SubmitButton';
import TextField from '../../../TextField/TextField';
import Title from '../../../Title/Title';

type CouponCodeFormFieldsProps = {
    trans: ReturnType<typeof useTrans>;
};

const CouponCodeFormFields = ({ trans }: CouponCodeFormFieldsProps) => {
    const [couponInputValue, setCouponInputValue] = useState('');
    const textFieldRef = useRef<HTMLInputElement>(null);

    const handleCouponCodeChange = (value: string) => {
        setCouponInputValue(value.toUpperCase());
    };

    useEffect(() => {
        setTimeout(() => {
            if (!textFieldRef.current) {
                return;
            }
            textFieldRef.current.focus();
        }, 100);
    }, [textFieldRef]);

    return (
        <Stack>
            <Title variant="area" align="center">
                {trans('ApplyCouponDialog.Title')}
            </Title>

            <Row horizontal="center">
                <TextField
                    placeholder={trans('ApplyCouponDialog.CodePlaceholder')}
                    autoComplete="off"
                    name="couponCode"
                    onChange={handleCouponCodeChange}
                    value={couponInputValue}
                    ref={textFieldRef}
                    data-1p-ignore
                />
            </Row>

            <Spacer vertical="none" />

            <Row horizontal="center">
                <SubmitButton size="large">
                    {trans('ApplyCouponDialog.SubmitButton')}
                </SubmitButton>
            </Row>
        </Stack>
    );
};

export default CouponCodeFormFields;
